<template>
  <div class="tools">
    <h1>Tools</h1>
    <h2>Locking</h2>
    <lock-panel
      title="All items"
      subtitle="Apply lock to all items"
      :items="lockable"
      :notMatched="lockable"
    >
    </lock-panel>
    <lock-panel
      title="Favorited"
      subtitle="Keep your favorited items safe"
      :items="favorited"
      :notMatched="notFavorited"
    >
    </lock-panel>
    <lock-panel
      title="Unique and best duplicates"
      subtitle="Lock all unique items"
      :items="bestDuplicates"
      :notMatched="worstDuplicates"
    ></lock-panel>
    <h2>Transfering</h2>

    <transfer-panel
      v-for="[tag, definition] in tagsDefinitions"
      :color="definition.color"
      :title="'Tag ' + tag"
      :items="forTag(tag)"
      :targets="characters"
      :key="tag"
    >
      Move items tagged with tag <strong>{{ tag }}</strong>
    </transfer-panel>


    <transfer-panel
      title="Favorites"
      :items="favorited"
      :targets="characters"
    >
      Move favorited items
    </transfer-panel>

    <transfer-panel
      title="Blue mods to vault"
      :items="blueModsLessThan3"
      :targets="[vault]"
    >
      Store for future
    </transfer-panel>
    <transfer-panel
      title="Blue mods to characters"
      :items="blueModsMoreThan3"
      :targets="[character]"
    >
      Exchange them to legendary
    </transfer-panel>

    <transfer-panel
      title="Unique / best duplicates"
      :items="uniqueWeapon"
      :targets="[vault]"
    >
      Store all unique not equpped weapon to vault, left duplicates are safe to dismantle
    </transfer-panel>
    <transfer-panel
      title="Worst duplicates"
      :items="worstDuplicatesToMove"
      :targets="characters"
    >
      Move words duplicates to selected character for dismantle
    </transfer-panel>
    <transfer-panel
      title="Not equipped weapon to vault"
      :items="notEquippedWeapon"
      :sources="characters"
      :targets="[vault]"
    >
      Make some space for new items
    </transfer-panel>
    <transfer-panel
      title="Not equipped armor to vault"
      :items="notEquippedArmor"
      :sources="characters"
      :targets="[vault]"
    >
      Make some space for new items
    </transfer-panel>
    <transfer-panel
      title="Trash"
      :items="trashItems"
      :targets="[...characters, vault]"
    >
      Not important items
    </transfer-panel>
  </div>
</template>

<script>
  import LockPanel from '../LockPanel.vue'
  import Item from '../Item.vue'
  import TransferPanel from '../TransferPanel.vue'

  export default {
    name: 'tools',
    props: [],
    data () {
      return {}
    },
    computed: {
      tagsDefinitions () {
        return Object.entries(this.$store.state.tagsDefinitions)
      },
      lockable () {
        return this.$store.state.destiny.profile.items.filter(item => item.canToggleLock)
      },
      favorited () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.canToggleLock && item.favorited)
      },
      notFavorited () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.canToggleLock && !item.favorited)
      },
      bestDuplicates () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.isImportant)
          .filter(item => item.canToggleLock && (!item.isDuplicate || item.isBestDuplicate))
      },
      worstDuplicates () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.canToggleLock && (item.isDuplicate && !item.isBestDuplicate))
      },
      blueMods () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.bucket.hash === 3313201758)
          .filter(item => item.tierType.hash === 2127292149)
      },
      blueModsMoreThan3 () {
        return this.blueMods.filter(item => item.data.quantity >= 3)
      },
      blueModsLessThan3 () {
        return this.blueMods.filter(item => item.data.quantity < 3)
      },
      uniqueWeapon () {
        return this.$store.state.destiny.profile.items
          .filter(item => !item.equipped)
          .filter(item => !item.isDuplicate)
          .filter(item => item.isWeapon)
          .filter(item => item.isImportant)
      },
      worstDuplicatesToMove () {
        return this.$store.state.destiny.profile.items.filter(item => item.isDuplicate && !item.isBestDuplicate)
      },
      notEquippedWeapon () {
        return this.$store.state.destiny.profile.items.filter(item => !item.equipped && item.isWeapon)
      },
      notEquippedArmor () {
        return this.$store.state.destiny.profile.items.filter(item => !item.equipped && item.isArmor)
      },
      trashItems () {
        return this.$store.state.destiny.profile.items
          .filter(item => item.isWeapon || item.isArmor)
          .filter(item => !item.equipped && !item.isImportant)
      },
      vault () {
        return this.$store.getters['destiny/profile/getCharacter']('VAULT')
      },
      character () {
        if (this.$store.state.destiny.profile.characters) {
          return Object.assign(
            this.$store.getters['destiny/profile/getCharacter']('INVENTORY'),
            {characterId: this.$store.state.destiny.profile.characters[0].characterId, isVault: false})
        }
      },
      characters () {
        return this.$store.state.destiny.profile.characters || []
      }
    },
    methods: {
      unLock (toUnlock) {
        return Promise.all(toUnlock.map(item => this.$store.dispatch('destiny/profile/unLockItem', {item})))
      },
      lock (toLock) {
        return Promise.all(toLock.map(item => this.$store.dispatch('destiny/profile/lockItem', {item})))
      },
      forTag (tag) {
        return this.$store.state.destiny.profile.items
          .filter(item => item.canToggleLock && item.hasTag(tag))
      }
    },
    components: {
      TransferPanel,
      Item,
      LockPanel
    }
  }
</script>

<style lang="scss">
  @import "../../styles/settings";

  .tools {
    padding: .5rem;
    .panel {
      max-width: 760px;
    }

  }
</style>



// WEBPACK FOOTER //
// Tools.vue?f82bb47c